"use client"
import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import { LogOut } from "lucide-react"
import { useTransition } from "react"
import { logout } from "./action"

export function NavLogout() {
  const [isPending, start] = useTransition()
  return (
    <DropdownMenuItem
      isLoading={isPending}
      onClick={async (e) => {
        e.preventDefault()
        start(() => logout())
      }}
    >
      <LogOut />
      <span>Logout</span>
    </DropdownMenuItem>
  )
}
